import * as React from "react";

function SvgExternalLink(props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) {
  return <svg viewBox="0 0 16 16" ref={svgRef} {...props}><g fill="currentColor" fillRule="evenodd"><path d="M13.3 4.457l-4.9 4.9-1.929-1.935L11.292 2.6 8.537.05 16 0v6.96zM5.545 0v2.043h-3.5v11.913h11.911V9.67H16V16H0V0z" /><path d="M15.999 0H8.484l7.515 7.515z" /></g></svg>;
}

const ForwardRef = React.forwardRef(SvgExternalLink);
export default ForwardRef;